import { render } from "./sysytemSubMenu.vue?vue&type=template&id=1adbf113&scoped=true"
import script from "./sysytemSubMenu.vue?vue&type=script&lang=js"
export * from "./sysytemSubMenu.vue?vue&type=script&lang=js"

import "./sysytemSubMenu.vue?vue&type=style&index=0&id=1adbf113&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/zh-center-resource-webui_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adbf113"]])

export default __exports__